export const GOVERNANCE_STAGES = Object.freeze([
  { key: 'planning', label: 'Investment Planning', path: '/investment-projects' },
  { key: 'proposal', label: 'Investment Proposal', path: '/investment-proposals' },
  { key: 'board-review', label: 'Board Review', path: null },
  { key: 'board-decision', label: 'Board Decision', path: '/board-decisions' },
  { key: 'program', label: 'Investment Program', path: '/investment-programs' },
  { key: 'execution', label: 'Program Execution', path: '/program-execution' },
  { key: 'benefits', label: 'Benefits Governance', path: '/benefits-governance' },
])

const owns = (pathname, route) => pathname === route || pathname.startsWith(`${route}/`)

// Conditional reauthorization routes deliberately remain outside the normal lifecycle.
export function governanceStageForPath(pathname = '') {
  if (owns(pathname, '/board-decisions/program-reauthorization')) return null
  if (owns(pathname, '/program-reauthorization')) return null
  if (owns(pathname, '/board/investment-proposals')) return 'board-review'
  if (owns(pathname, '/board-decisions')) return 'board-decision'
  if (owns(pathname, '/investment-projects')) return 'planning'
  if (owns(pathname, '/investment-proposals')) return 'proposal'
  if (owns(pathname, '/investment-programs')) return 'program'
  if (owns(pathname, '/program-execution')) return 'execution'
  if (owns(pathname, '/benefits-governance')) return 'benefits'
  return null
}

export function governanceReferenceForPath(pathname = '') {
  const patterns = [
    ['/board/investment-proposals/', 'Proposal'], ['/investment-proposals/', 'Proposal'],
    ['/board-decisions/', 'Decision'], ['/investment-projects/', 'Project'],
    ['/investment-programs/', 'Program'], ['/program-execution/', 'Program'],
    ['/benefits-governance/', 'Program'],
  ]
  for (const [prefix, type] of patterns) {
    if (pathname.startsWith(prefix)) {
      const reference = decodeURIComponent(pathname.slice(prefix.length).split('/')[0])
      if (reference && reference !== 'new') return { type, reference }
    }
  }
  return null
}

const targetContext = (action) => action?.target?.context || {}
const route = (prefix, reference) => reference ? `${prefix}/${encodeURIComponent(reference)}` : null

// Governed action legitimacy is wholly backend-owned. This mapper only connects a
// known action identity and its authoritative target to an existing UI route.
export function resolveGovernedActionRoute(action) {
  const context = targetContext(action)
  switch (action?.action_type) {
    case 'SUBMIT_INVESTMENT_PROPOSAL':
      return route('/investment-proposals', context.proposal_reference)
    case 'RECORD_INITIAL_BOARD_DECISION':
      return route('/board/investment-proposals', context.proposal_reference)
    case 'MOBILIZE_INVESTMENT_PROGRAM':
      return route('/board-decisions', context.board_decision_reference)
    case 'ACTIVATE_PROGRAM_PROJECT':
      return route('/investment-programs', context.participation_key?.program_reference)
    case 'PREPARE_PROGRAM_REAUTHORIZATION':
    case 'SUBMIT_PROGRAM_REAUTHORIZATION':
      return route('/benefits-governance', context.program_reference)
    case 'RECORD_PROGRAM_REAUTHORIZATION_DECISION':
    case 'APPLY_PROGRAM_REAUTHORIZATION':
      return route('/board-decisions/program-reauthorization', context.request_reference)
    default:
      return null
  }
}
